import JobDetails from './JobDetails.container';

export default JobDetails;
